module.exports = __webpack_public_path__ + "static/media/icon-hospitality.a8423444.svg";